import { organizationList, locationLine } from "./organizationHelpers";

/**
 * The organization(s) on a provider search card. One organization looks like it always has; when a
 * provider works at several, every one is listed under a "Works at N organizations" label, and each
 * extra shows its own location and phone (the main listing's address is already on the card).
 */
export default function ProviderOrganizations({ provider }) {
  const orgs = organizationList(provider);
  if (orgs.length === 0) return null;
  const several = orgs.length > 1;

  return (
    <div style={{ margin: "0 0 6px" }}>
      {several && (
        <p style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", letterSpacing: 0.4, textTransform: "uppercase", margin: "0 0 3px" }}>
          Affiliated with {orgs.length} organizations
        </p>
      )}
      {orgs.map((o, i) => {
        const where = o.primary ? "" : locationLine(o);
        return (
          <div key={`${o.name}-${i}`} style={{ margin: "0 0 3px" }}>
            <p style={{ fontSize: 12, color: "#374151", margin: 0, fontWeight: 500 }}>
              {several ? "🏥 " : ""}
              {o.name}
            </p>
            {where && <p style={{ fontSize: 11, color: "#9ca3af", margin: 0 }}>📍 {where}</p>}
            {!o.primary && o.phone && <p style={{ fontSize: 11, color: "#9ca3af", margin: 0 }}>📞 {o.phone}</p>}
          </div>
        );
      })}
    </div>
  );
}
